import React from 'react';
import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase} from '@material-ui/core';

// project imports
import config from './../../../config';
import LogoDark from './../../../ui-component/LogoDark';

//-----------------------|| MAIN LOGO ||-----------------------//

const LogoSectionDark = () => {

    return (
        <ButtonBase disableRipple component={Link} to={config.defaultPath}>
            <LogoDark />
        </ButtonBase>
    );
};

export default LogoSectionDark;
